import {downloadFileFromResponse, takeLatestF, showBeError, putAll} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {getRequestedTableCsvExportParams, simpleTableSelector} from 'utils/tables';

import {animalBrowserAction, GetCalvesCsvAction} from '../action';

function* execute({payload}: GetCalvesCsvAction): SagaIterator {
    yield* put(animalBrowserAction.startExport());
    const tableState = opt(yield* select(simpleTableSelector.tableState('calfBrowser'))).orCrash('no tableState');

    const {fieldParams, sort} = getRequestedTableCsvExportParams(tableState);

    const pathParams = {farmId: payload};

    const response = yield* call(Api.exportCalvesByFarm, fieldParams, {sort}, pathParams);

    if (response.isSuccess) {
        yield* call(downloadFileFromResponse, response);
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('exportCalvesInFarm')));
    }
    yield* put(animalBrowserAction.exportFinished());
}

/**
 * Exports calf-browser data as CSV.
 *
 * @returns The saga watcher for `GET_CALVES_CSV`.
 */
export function* getCalvesCsvSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_CALVES_CSV', execute);
}
